import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Redirect, useLocation } from 'react-router-dom';
import {
  Dimmer,
  Icon,
  Loader,
  Menu,
  Segment,
  Sidebar,
} from 'semantic-ui-react';
import BeekinLogo from '../../assets/beekin-logo.png';
import { logout, setTimeZone } from '../../redux/actions/auth';
import { StoreState } from '../../types/state';

function AppContainer({ children }) {
  let activeItem = 'search';
  const { isAuthenticated, isLoading, timezone } = useSelector(
    (state: StoreState) => {
      return {
        ...state.auth,
        isLoading: state.tasks.isLoading,
        authLoading: state.auth.isLoading,
      };
    }
  );

  const { pathname } = useLocation();

  const dispatch = useDispatch();

  if (!isAuthenticated)
    return (
      <Redirect
        to={{
          pathname: '/auth',
          state: { from: pathname },
        }}
      />
    );
  const handleTimezoneChange = () => {
    dispatch(setTimeZone(timezone === 'UTC' ? true : false));
  };

  const handleLogout = () => {
    dispatch(logout());
  };
  return (
    <Sidebar.Pushable as={Segment}>
      {isLoading ? (
        <Dimmer page>
          <Loader />
        </Dimmer>
      ) : null}
      <Sidebar
        animation="push"
        icon="labeled"
        inverted={'true'}
        vertical={'true'}
        visible
        width="thin"
      >
        <img src={BeekinLogo} alt="beekin" width="150px" />

        <Menu vertical inverted fluid icon="labeled">
          <Menu.Item>
            <Link to={'/clients'}>
              <Icon name="dollar" />
              Clients
            </Link>
            <Menu.Menu>
              <Menu.Item
                as={Link}
                to={'/clients/add'}
                name="clints"
                active={activeItem === 'search'}
              >
                Add
              </Menu.Item>
              <Menu.Item
                as={Link}
                to={'/clients/view'}
                name="add"
                active={activeItem === 'add'}
              >
                View/Manage
              </Menu.Item>
            </Menu.Menu>
          </Menu.Item>
          <Menu.Item as={Link} to={'/tasks'}>
            <Icon name="tasks" />
            Tasks
          </Menu.Item>
          <Menu.Item as={Link} to={'/jobs'}>
            <Icon name="calendar" />
            Jobs
          </Menu.Item>
          <Menu.Item as={Link} to={'/users/add'}>
            <Icon name="user" />
            Users
          </Menu.Item>
          <Menu.Item>
            {timezone}
            <button onClick={handleTimezoneChange}>
              {timezone === 'UTC' ? 'Use Local Time' : 'Use UTC Time'}
            </button>
          </Menu.Item>
          <Menu.Item>
            <button onClick={handleLogout}>Logout</button>
          </Menu.Item>
        </Menu>
      </Sidebar>

      <Sidebar.Pusher style={{ width: 'calc(100% - 150px)', height: '100%' }}>
        <Segment style={{ height: '100%', overflow: 'auto' }} basic>
          {children}
        </Segment>
      </Sidebar.Pusher>
    </Sidebar.Pushable>
  );
}

export default AppContainer;
